import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $bgColor?: string;
  $textColor?: string;
  $pointColor?: string;
  $emphasisTextColor?: string;
}

export const HighlightPickSection2 = styled.div<IProps>`
  padding: 32px 0;
  background: #fff;

  ${({ $bgColor, $textColor, $pointColor, $emphasisTextColor }) =>
    $bgColor &&
    css`
      background-color: ${$bgColor};
      color: ${$textColor};

      .content-sub-title,
      .content-title {
        color: ${$textColor};
      }

      .items-swiper > .swiper-button-next svg path,
      .items-swiper > .swiper-button-prev svg path {
        fill: ${$textColor};
      }

      .product-item .tag.tag-soldout {
        background: rgba(172, 172, 172, 0.15);
        color: #000;
      }
    `}

  .content-title,
  .content-sub-title {
    padding: 0 20px;

    + .list,
    + .items-swiper {
      margin-top: 12px;
    }
  }

  .content-sub-title {
    margin-top: 4px;
  }

  /* 모바일 캐러셀: 좌우 20px 여백 안쪽에 아이템, 여백으로 이전/다음 아이템이 살짝 보임
     (Swiper는 el의 padding을 빼고 slide 너비를 계산하고, overflow는 padding box 기준으로 잘린다) */
  .highlight-pick-list > .items-swiper-swiper {
    padding: 0 20px;
  }

  &.bg-type-black {
    background: #000;

    .content-title {
      color: #fff;
    }

    .content-sub-title {
      color: #777;
    }

    .img-banner .area-info {
      .text-wrap {
        .text {
          color: #fff;
        }
      }

      .icon-arrow svg path {
        fill: #fff;
      }
    }

    .basic-btn {
      color: #fff;
      border-color: #555;

      .icon-arrow svg path {
        stroke: #fff;
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 0')};

    .content-title,
    .content-sub-title {
      padding: 0 ${mixin.pxToVw('20')};

      + .list,
      + .items-swiper {
        margin-top: ${mixin.pxToVw('12')};
      }
    }

    .content-sub-title {
      margin-top: ${mixin.pxToVw('4')};
    }

    .highlight-pick-list > .items-swiper-swiper {
      padding: 0 ${mixin.pxToVw('20')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 65px 57px;

    .content-title,
    .content-sub-title {
      padding: 0;
      margin: 0 auto;

      + .items-swiper {
        margin-top: 20px;
      }
    }

    .content-title {
      font-size: 42px;
      line-height: 130%;
    }

    .content-sub-title {
      font-size: 18px;
      line-height: 135%;
      margin-top: 6px;
    }

    .items-swiper > .swiper-pagination-fraction02Medium {
      margin-top: 48px;
    }
  }
`;
